<template>
  <div class="capsule-card">
    <div class="capsule-image">
      <ImageWrapper :src="capsule.imgPath" :alt="capsule.name" />
    </div>
    <div class="capsule-info">
      <h3 class="capsule-name">{{ capsule.name }}</h3>
      <p class="capsule-description">{{ capsule.desc }}</p>

      <div v-if="capsule.props" class="taste-ratings">
        <TasteRating
          v-for="prop in capsule.props"
          :key="prop.name"
          :label="prop.name"
          :rating="prop.value"
        />
      </div>

      <p class="capsule-price">
        HKD{{ selectedTab == "vertuoPop" ? "$113" : "$78" }}
      </p>
      <div class="capsule-actions">
        <addToCart :id="capsule.sku" :needRelpace="true" :isShow="isVisible" />
      </div>
    </div>
  </div>
</template>

<script>
import TasteRating from "../atoms/TasteRating.vue";
import addToCart from "../atoms/addToCart.vue";
import { ImageWrapper } from "~/components/";

export default {
  name: "CapsuleCard",
  components: {
    TasteRating,
    addToCart,
    ImageWrapper,
  },
  props: {
    isVisible: { type: Boolean, default: false },

    selectedTab: {
      type: String,
    },
    /**
     * Capsule object containing capsule information and taste ratings
     * Expected structure: { name, desc, sku, imgPath, props: [{ name, value }] }
     */
    capsule: {
      type: Object,
      required: true,
      validator: (capsule) => {
        return capsule && capsule.name && capsule.imgPath && capsule.sku;
      },
    },
  },
};
</script>

<style lang="scss">
@import "~/scss/include/_commonInclude.scss";

.content .app {
  .capsule-card {
    display: flex;
    // flex-direction: column;
    gap: rem(16);
    // padding: rem(16);

    // @include media-breakpoint-up(md) {
    flex-direction: row;
    align-items: flex-start;
    // gap: rem(24);
    // }

    .capsule-image {
      display: flex;
      align-items: center;
      justify-content: center;
      min-height: rem(120);
      flex-shrink: 0;

      width: rem(140);
      height: rem(140);

      @include media-breakpoint-down(md) {
        width: 30%;
        height: auto;
        min-height: unset;
      }

      img {
        width: 100%;
        height: 100%;
        @include media-breakpoint-down(md) {
          width: 100%;
          max-width: rem(120);
          max-height: rem(120);
        }
        border-radius: rem(48);
        object-fit: cover;

        max-width: rem(140);
        max-height: rem(140);
      }
    }

    .capsule-info {
      flex: 1;
      display: flex;
      flex-direction: column;
      gap: rem(8);

      .capsule-name {
        font-family: "Nespresso Lucas", sans-serif;
        font-weight: 700;
        font-size: rem(24);
        color: color(black);
        line-height: 1.2;
        margin: 0;

        @include media-breakpoint-up(md) {
          font-size: rem(32);
        }
      }

      .capsule-description {
        font-family: "Nespresso Lucas", sans-serif;
        font-weight: 400;
        font-size: rem(14);
        color: color(black);
        line-height: 1.2;
        margin: 0;

        @include media-breakpoint-up(md) {
          font-size: rem(16);
        }
      }

      .taste-ratings {
        margin: rem(12) 0;
        display: flex;
        flex-direction: column;
        gap: rem(4);
      }

      .capsule-price {
        font-family: "Nespresso Lucas", sans-serif;
        font-weight: 700;
        font-size: rem(18);
        color: color(black);
        letter-spacing: rem(1);
        text-align: left;
        margin: rem(8) 0;

        @include media-breakpoint-up(md) {
          font-size: rem(20);
        }
      }

      .capsule-actions {
        display: flex;
      }
    }
  }
}
</style>
